/**
 * Offline queue voor POS-bestelbonnen.
 * Bestelbonnen die offline worden aangemaakt → in localStorage.
 * Bij online: retry en sync met backend, toon feedback.
 */
const QUEUE_KEY = 'verkoop_offline_queue_v1';

export function leesQueue() {
  try {
    return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]');
  } catch { return []; }
}

export function saveQueue(queue) {
  try { localStorage.setItem(QUEUE_KEY, JSON.stringify(queue)); } catch { /* storage vol */ }
  // Notify listeners that legacy queue changed (OfflineStatus widget en andere observers)
  try { window.dispatchEvent(new CustomEvent('verkoop-queue-change', { detail: { size: queue.length } })); } catch { /* noop */ }
}

export function voegToeAanQueue(bestelbon) {
  const q = leesQueue();
  const local_id = `offline-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  q.push({ local_id, aangemaakt: new Date().toISOString(), payload: bestelbon, retries: 0, laatste_fout: null });
  saveQueue(q);
  return local_id;
}

export function verwijderUitQueue(local_id) {
  saveQueue(leesQueue().filter(i => i.local_id !== local_id));
}

export function markeerFout(local_id, fout) {
  const q = leesQueue();
  const item = q.find(i => i.local_id === local_id);
  if (item) {
    item.retries = (item.retries || 0) + 1;
    item.laatste_fout = String(fout).slice(0, 200);
    saveQueue(q);
  }
}

/**
 * Synchroniseer alle wachtende items naar backend.
 * Retourneert { gesync: N, overgeslagen: N, fouten: [...] }
 */
export async function syncQueue(API) {
  const q = leesQueue();
  if (q.length === 0) return { gesync: 0, overgeslagen: 0, fouten: [] };
  let gesync = 0;
  const fouten = [];
  for (const item of [...q]) {
    if (item.retries >= 5) { continue; } // opgeven na 5 pogingen
    try {
      await API.post('/documenten', item.payload);
      verwijderUitQueue(item.local_id);
      gesync++;
    } catch (e) {
      markeerFout(item.local_id, e.response?.data?.detail || e.message);
      fouten.push({ local_id: item.local_id, fout: e.message });
    }
  }
  return { gesync, overgeslagen: leesQueue().length, fouten };
}
